import { isGqlError } from '@conteg/ui';

/**
 * Reads `extensions.errorCode` from the first GraphQL error and maps it to an
 * i18n key via the provided table. Falls back to `fallbackKey` when the
 * input is not a GraphQL error, no code is present, or the code is unknown.
 *
 * The generic `Code` parameter lets the caller pass a string-literal union so
 * the table stays type-checked at the call site.
 */
export const resolveGqlErrorMessageKey = <Code extends string>(
  error: unknown,
  codeToI18nKey: Readonly<Record<Code, string>>,
  fallbackKey: string
): string => {
  if (!isGqlError(error)) return fallbackKey;
  const errors = error.errors as
    | Array<{ extensions?: { errorCode?: string } }>
    | undefined;
  const code = errors?.[0]?.extensions?.errorCode as Code | undefined;
  return (code && codeToI18nKey[code]) || fallbackKey;
};
